export default __webpack_public_path__ + "static/media/thanks_round_3.82b2ee48.gif";